import { combineReducers } from 'redux';
import { createSelector } from 'reselect';

import { createReducer } from './utils';

import * as ActionTypes from '../app/ActionTypes';

/*
	Reducer cases
*/

function applySetLockings(state, action) {
	return action.lockingsByIds;
}

/*
	Reducer
*/

const initialState = {};

const reducer = combineReducers({
	byIds: createReducer(initialState, {
		[ActionTypes.GET_LOCKINGS_SUCCESS]: applySetLockings,
		[ActionTypes.SAVE_LOCKING_SUCCESS]: applySetLockings,
		[ActionTypes.CLONE_LOCKING_SUCCESS]: applySetLockings,
		[ActionTypes.DELETE_LOCKING_SUCCESS]: applySetLockings,
		[ActionTypes.MOVE_LOCKING_SUCCESS]: applySetLockings,
		CLEAR_PLAN_DATAS: (state, action) => initialState
	})
});

// allIds.map(id => {
//   if (id === parent) {
//     state[id].rgt++;
//   }
// });

/*
*	Selectors
*/
export const getLockings = state => {
	const { lockings } = state.entities;
	const lockingsIds = Object.keys(lockings.byIds);
	return lockingsIds.map(id => lockings.byIds[id]);
};

export const getLocking = state => lockingId => {
	const { lockings } = state.entities;
	return lockings.byIds[lockingId];
};

export const getLockingsAsTree = createSelector(getLockings, lockings =>
	buildTree(lockings)
);

const lockingsSelector = state => state.entities.lockings.byIds;

const getRootLockingSelector = createSelector(
	lockingsSelector,
	lockingsByIds => {
		const lockingsIds = Object.keys(lockingsByIds);
		const rootLocking = lockingsIds.find(
			lockingId =>
				// Need '==', lockingId(String), lockingsByIds[lockingId].root(Number)
				lockingId == lockingsByIds[lockingId].root
		);

		if (!rootLocking) return {};
		return lockingsByIds[rootLocking];
	}
);

const getLockingsSelector = createSelector(lockingsSelector, lockingsByIds => {
	const lockingsIds = Object.keys(lockingsByIds);
	const lockings = lockingsIds.map(lockingId => lockingsByIds[lockingId]);
	return lockings;
});

const getLockingsWithoutRootSelector = createSelector(
	getLockingsSelector,
	lockings => lockings.filter(locking => locking.locking_id !== locking.root)
);

const getTrueLockingsSelector = createSelector(
	getLockingsSelector,
	lockings => {
		return lockings.filter(locking => locking.is_locking);
	}
);

const getGroupsSelector = createSelector(lockingsSelector, lockingsByIds => {
	const lockingsIds = Object.keys(lockingsByIds);
	const groups = lockingsIds.filter(lockingId => {
		if (
			!lockingsByIds[lockingId].is_locking &&
			lockingId != lockingsByIds[lockingId].root
		) {
			return true;
		} else {
			return false;
		}
	});
	return groups;
});

const getNestMapLockingsSelector = createSelector(
	getLockingsSelector,
	lockings => {
		if (lockings.length === 0) return [];

		// Sort lockings by left
		lockings = lockings.sort((lockingA, lockingB) => {
			return lockingA.lft - lockingB.lft;
		});

		const map = [];
		const rootLockingId = lockings[0].locking_id;
		let parentLocking = {};
		let children = [];

		lockings.forEach(locking => {
			// No root;
			if (locking.locking_id === locking.root) {
				return;
			}

			if (parentLocking) {
				const endOfGroup = locking.rgt + 1 === parentLocking.rgt;
				if (endOfGroup) {
					children.push({
						...locking,
						locking_id: locking.locking_id,
						parent_locking_id: parentLocking.locking_id
					});
					map.push({
						...parentLocking,
						locking_id: parentLocking.locking_id,
						parent_locking_id: rootLockingId,
						children: children
					});
					parentLocking = {};
					children = [];
					return;
				} else if (parentLocking.locking_id) {
					children.push({
						...locking,
						locking_id: locking.locking_id,
						parent_locking_id: parentLocking.locking_id
					});
					return;
				}
			}

			if (isGroup(locking)) {
				if (hasChildren(locking)) {
					parentLocking = locking;
					return;
				}
				// Group without children
				map.push({
					...locking,
					locking_id: locking.locking_id,
					parent_locking_id: rootLockingId,
					children: []
				});
				return;
			}
			map.push({
				...locking,
				locking_id: locking.locking_id,
				parent_locking_id: rootLockingId
			});
		});
		return map;
	}
);

function isGroup(locking) {
	return !locking.is_locking;
}

function hasChildren(locking) {
	return locking.lft - locking.rgt !== -1;
}

export default reducer;
export {
	lockingsSelector,
	getLockingsSelector,
	getRootLockingSelector,
	getLockingsWithoutRootSelector,
	getTrueLockingsSelector,
	getGroupsSelector,
	getNestMapLockingsSelector
};



// WEBPACK FOOTER //
// ./src/js/reducers/lockings.js